import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory, useParams, useLocation } from "react-router-dom";
import useFetch from '../../useFetch';
import { Row, Col, Container } from 'react-bootstrap';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { getProductAutocompleteByMolecule, getProductAutocompleteByBrand } from '../../Services/ProductSearchService'
import { logPageViews } from '../../Services/LoginService.js';
import { IconSearch, IconUserSquareRounded, IconInfoCircleFilled,IconListSearch, IconCaretDownFilled, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, Select, InputLabel, Skeleton, CircularProgress, Accordion, AccordionSummary, ButtonGroup, AccordionDetails, TextField, Link, Checkbox,Collapse, Divider, InputAdornment, ListItemButton, ListSubheader, Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../../styles/PregnancyLactation.scss'
import { getMimsClasses } from '../../Services/MimsClassService'
import { getPregnancy } from '../../Services/PregnancyService'
import { ReactComponent as ClampClip } from '../../assets/PaperClamp.svg'
import Illustration from '../../assets/ModuleIllustrations/PregnancyLactationGuide.svg';
import IllustrationNZ from '../../assets/ModuleIllustrations/NZ/PregnancyLactationGuide.svg';
import { useThemeManager } from '../../Context/ThemeManager.js';
//import parse from 'html-react-parser'
const PregnancyLactationGuide = () => {
    const {theme} = useThemeManager();
    const [activeButton, setActiveButton] = useState('pregnancy');
    //const params = new URLSearchParams(search);
    const [classes, setClasses] = useState([])
    const [mimsClass, setMimsClass] = useState('')
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(1);
    const [brands, setBrands] = useState([])
    const [molecules, setMolecules] = useState([])
    const [operator, setOperator] = useState('OR')
    const [selectedActiveIngredient, setSelectedActiveIngredient] = useState('');
    const isLgScreen = useMediaQuery('(min-width:1024px)');
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const { error, isPending, data } = useFetch('api/MimsDrug4dent/GetDosingCalculationDrugName');
    if (isPending) {
        document.getElementById('loaderPage').style.display = 'flex'
    } else {
        document.getElementById('loaderPage').style.display = 'none'
    }
    //Show loader
    function showLoader() {
        const el = document.getElementById("loader");
        if (el) {
        console.log("Before:", el.style.display);
        el.style.setProperty("display", "flex", "important");
        el.style.zIndex = "1000";
        console.log("After:", el.style.display);
        }
    }
    // Hide loader
    function hideLoader() {
    const el = document.getElementById("loader");
    if (el) {
        el.style.display = "none";
    }
    }

    const country = localStorage.getItem("Activecountryversion");
    useEffect(() => {
        document.title = "Pregnancy & Lactation Guide"
        getMimsClasses().then(items => { setClasses(items) })
        document.documentElement.style.setProperty('--primary-color', theme.primary);
        document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
        document.documentElement.style.setProperty('--bg', theme.bg);

    }, [])

    useEffect(()=> {
        logPage(); 
        async function logPage() {
            await logPageViews('Pregnancy',selectedActiveIngredient ?? "")
        }
    }, [selectedActiveIngredient])
    const [pregnancyD4DResult, setPregnancyD4DResult] = useState([]);

    async function handleDrugChange(event) {
        if (event != null) {
          showLoader(); // 👈 Show loader when item is selected
          setIsLoading(true);
          setSelectedActiveIngredient(event.label);
      
          try {
            const res = await fetch(
              `${process.env.REACT_APP_APIDrug4dents_URL}api/MimsDrug4dent/GetPregnancyAndLactation?drugName=${event.value}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('sessionId').replaceAll('"', '')}`,
                },
              }
            );
      
            const data = await res.json();
            setPregnancyD4DResult(data);
          } catch (error) {
            console.error('Failed to fetch pregnancy data:', error);
          } finally {
            hideLoader(); // 👈 Hide loader whether success or error
            setIsLoading(false);
            handleScrollToGuides();
        }
        }
      }
       // Scroll window to fit drug list and guides
       const handleScrollToGuides = () => {
        window.scrollTo({
          top: 176,
          behavior: 'smooth'
        });
      };
    return (

        <>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>  
            <Banner />
            <Sidebar activeButton={activeButton} />
            <div id="PregnancyLactation">
                <Container fluid id="main">
                    <div id="content">
                        <div id="contentCaption">
                            <h2>Pregnancy & Lactation Guide</h2>
                            {isLgScreen && (
                                <span>Identify the safety of dental medicines in pregnancy and lactation.</span>
                            )}
                        </div>
                        <Row id="guides" style={{gap: 20}} className={ isLgScreen ? 'my-3 d-flex flex-row' : 'my-4 d-flex flex-row'}>
                           <Col lg={12} id="search" className='p-0'>
                                <div className='d-flex p-0' style={{color: theme.primary}}>
                                    <IconListSearch style={{marginRight: 8}}/>
                                    <h5 style={{ fontWeight: "bold", marginBottom: "12px", }}>
                                        Active Ingredient
                                    </h5>
                                </div>
                                { !data ? (
                                    <Skeleton
                                        variant="rectangular"
                                        height={48}
                                        sx={{ borderRadius: '12px' }}
                                    />
                                    ) : (
                                    <Autocomplete
                                        blurOnSelect
                                        options={data}
                                        getOptionLabel={(option) => option.name || ''}
                                        value={
                                            data.length && selectedActiveIngredient
                                                ? data.find(option => option.name === selectedActiveIngredient)
                                                : null
                                            }
                                        onChange={(event, newValue) => {
                                            if (newValue){
                                                handleDrugChange(
                                                    newValue ? { value: newValue.id, label: newValue.name } : null
                                                );
                                            }
                                       
                                        }}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Active Ingredient"
                                            InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                <InputAdornment position="start">
                                                    <IconSearch size={20} />
                                                </InputAdornment>
                                                {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            
                                            }}
                                            inputProps={{
                                            ...params.inputProps,
                                            style: selectedActiveIngredient
                                                ? { fontWeight: 'bold', color: theme.primary }
                                                : {},
                                            }}
                                        />
                                        )}
                                        clearOnEscape
                                    />
                                    )}

                            </Col> 
                            {pregnancyD4DResult && pregnancyD4DResult.length > 0 && pregnancyD4DResult[0].pregnancyInfo ? (
                            <Col lg={12} id="results">
                                <>
                                <div id="activeIngredient">
                                    <h3 style={{fontWeight: "bold"}}>{selectedActiveIngredient}</h3>
                                </div>
                                {/* <hr className="my-3"style={{borderColor: "#727272"}}/> */}
                                <Box id="details" sx={{ mt: 2, px: isLgScreen ? "48px" : "20px", pb: "36px" }}>
                                    <Box sx={{ my: isLgScreen ? 5: 3 }}>
                                        <Row>
                                            <Col xl={2} lg={3} md={12} xs={12} className="d-flex flex-column" style={{ marginBottom: isLgScreen ? 16 : 0 }}>
                                                <strong className="col-lg-12" style={{ color: "#727272", fontSize: 16, marginBottom: "8px" }}>
                                                Guide in Pregnancy:
                                                </strong>
                                            </Col>
                                            <Col lg={6} md={12} xs={12} className="d-flex flex-column" style={{ marginBottom: isLgScreen ? 16 : 0 }}>
                                                {isLoading ? (
                                                <>
                                                    <Skeleton animation="wave" height={20} sx={{ mb: 1 }} />
                                                    <Skeleton animation="wave" height={20} sx={{ mb: 1 }} />
                                                    <Skeleton animation="wave" height={20} sx={{ mb: 1 }} />
                                                </>
                                                ) : (
                                                pregnancyD4DResult[0].pregnancyInfo
                                                    .split("\\r\\n")
                                                    .map((instruction, index) => <div key={index}>{instruction}</div>)
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="my-4">
                                            <Col xl={2} lg={3} md={12} xs={12} className="d-flex flex-column" style={{ marginBottom: isLgScreen ? 16 : "" }}>
                                                <strong style={{ color: "#727272", fontSize: 16, marginBottom: "8px" }}>
                                                Guide in Lactation:
                                                </strong>
                                            </Col>
                                            <Col lg={6} md={12} xs={12} className="d-flex flex-column" >
                                                {isLoading ? (
                                                <>
                                                    <Skeleton animation="wave" height={20} sx={{ mb: 1 }} />
                                                    <Skeleton animation="wave" height={20} sx={{ mb: 1 }} />
                                                    <Skeleton animation="wave" height={20} sx={{ mb: 1 }} />
                                                </>
                                                ) : (
                                                pregnancyD4DResult[0].lactaionInfo
                                                    ?.split("\\r\\n")
                                                    .map((instruction, index) => <div key={index} >{instruction}</div>)
                                                )}
                                            </Col>
                                        </Row>
                                    </Box>
                                    <hr className="my-3"style={{borderColor: "#727272"}}/>
                                    <Col lg={12} className="d-flex flex-column mt-4">
                                        <strong style={{ color: "#727272", fontSize: 12, marginBottom: "8px" }}>
                                            References
                                        </strong>

                                        {isLoading ? (
                                            <Skeleton animation="wave" height={20} sx={{ mt: 1 }} />
                                        ) : (
                                            <ul style={{ paddingLeft: isLgScreen ? 32 : 16, listStyleType: 'disc', margin: 0 }}>
                                                {pregnancyD4DResult[0].referenceInfo
                                                    ?.split("\\r\\n")
                                                    .filter(Boolean)
                                                    .map((item, index) => {
                                                    const urlRegex = /(https?:\/\/[^\s]+)/g;
                                                    const cleanedItem = item.replaceAll('\\"', '').replace(/^\s*[-•*]\s*/, '');
                                                    const parts = cleanedItem.split(urlRegex);

                                                    return (
                                                        <li key={index} style={{ color: "#727272", fontSize: 12, marginTop: 8 }}>
                                                        {parts.map((part, i) => {
                                                            const isUrl = urlRegex.test(part);
                                                            const cleanedUrl = isUrl ? part.replace(/[.,!?;]$/, '') : part;

                                                            return isUrl ? (
                                                            <a
                                                                key={i}
                                                                href={cleanedUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ wordBreak: 'break-word', color: theme.primary }}
                                                            >
                                                                {cleanedUrl}
                                                            </a>
                                                            ) : (
                                                            <span key={i}>{parse(part)}</span> // ✅ Parse HTML here
                                                            );
                                                        })}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </Col>
                                </Box>
                                </>
                            </Col>
                             ):(
                            <div id="illustration-container" style={{textAlign: "center"}} >
                                <h6 style={{lineHeight: 1.5}}>SELECT AN ACTIVE INGREDIENT FROM THE LIST TO VIEW PREGNANCY AND LACTATION GUIDES.</h6>
                                <img src={country === "New Zealand" ? IllustrationNZ : Illustration} alt="Illustration" id="illustration" style={{ maxWidth: '100%', height: 'auto' }} />
                            </div>
                             )
                             }
                        </Row>
                    </div>
                </Container>
            </div>
        </>

    );
}

export default PregnancyLactationGuide;